const ProjectsPage = () => {
  return (
    <>
      <section className="content-wrap">
        <h2>Featured Projects</h2>

        <h3>Mechanical Design</h3>
        <ul>
          <li>High-end laser projection systems</li>
          <li>Structural support for large screens</li>
          <li>Large format inkjet printers</li>
          <li>MRI-compatible surgical actuators</li>
          <li>High-accuarcy, long-range piezoelectric-based stages</li>
          <li>DC motors coupled to clutches, brakes and gearheads</li>
          <li>Linear sensors (LVDT) and systems</li>
          <li>Tooling for assembly and testing</li>
          <li>Automotive seat recliners</li>
          <li>City bus industrial design</li>
        </ul>

        <h3>Data Analysis</h3>
        <ul>
          <li>
            data manipulations on Jira extracts for project tracking and
            estimating (Python)
          </li>
          <li>
            data extracts from online change control tracking database (Perl)
          </li>
          <li>
            data analysis on SAP extracts for product cost and efficiencies
            (Excel VBA)
          </li>
        </ul>

        <h3>Business Automation</h3>
        <ul>
          <li>build order template based on order intake (Excel VBA)</li>
          <li>JIRA data extracts for project tracking (Python, REST API)</li>
          <li>
            new drawing database system developed and implemented
            (SAP,Creo,Python)
          </li>
          <li>mass AutoCAD file processing (AutoCAD VBA)</li>
          <li>
            mass Solidworks file processing with PDM database cleanup
            (Solidworks, C#)
          </li>
          <li>drawing database with auto maintenance (AutoCAD VBA)</li>
          <li>
            SolidWorks model and drawing automated checks and batch updates
            (Solidworks VBA)
          </li>
        </ul>

        <h3>Automated Test and Measurement Stations</h3>
        <ul>
          <li>
            automated DC motor test station full mechatronic development (C)
          </li>
          <li>vibration stand control programming (C)</li>
          <li>process control trainers (Siemens PLC)</li>
        </ul>
      </section>
    </>
  );
};

export default ProjectsPage;
